import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/DatePicker/calendarViews.js",
    _this = this;

import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { isAfter } from 'date-fns';
import DatePickerCalendarContainer from './DatePickerCalendarContainer';
import Calendar from '../Calendar';
import { formatDate } from '../../core/utils';
export var SingleDatePickerCalendar = function SingleDatePickerCalendar(_ref) {
  var _ref$datePickerProps = _ref.datePickerProps,
      datePickerProps = _ref$datePickerProps === void 0 ? {} : _ref$datePickerProps,
      _ref$calendarProps = _ref.calendarProps;
  _ref$calendarProps = _ref$calendarProps === void 0 ? {} : _ref$calendarProps;
  var availableDays = _ref$calendarProps.availableDays,
      defaultOptions = _ref$calendarProps.defaultOptions,
      useSelectedDate = _ref.useSelectedDate,
      useDropdownVisible = _ref.useDropdownVisible,
      formatter = _ref.formatter,
      disabledDays = _ref.disabledDays;

  var _useDropdownVisible = useDropdownVisible(),
      setDropDownVisible = _useDropdownVisible.setDropDownVisible;

  var _useSelectedDate = useSelectedDate(),
      selectedDate = _useSelectedDate.selectedDate,
      setSelectedDate = _useSelectedDate.setSelectedDate;

  var _useState = useState(selectedDate || defaultOptions.month),
      _useState2 = _slicedToArray(_useState, 2),
      currentMonth = _useState2[0],
      setCurrentMonth = _useState2[1];

  var originalSelectedDate = useMemo(function () {
    return selectedDate;
  }, []);
  var Container = useCallback(function (_ref2) {
    var children = _ref2.children,
        selectedDays = _ref2.selectedDays;
    return /*#__PURE__*/React.createElement(DatePickerCalendarContainer, {
      onClear: function onClear() {
        setSelectedDate();
        datePickerProps.onChange();
        datePickerProps.onClear();
      },
      onConfirm: function onConfirm() {
        datePickerProps.onConfirm(selectedDays);
        setDropDownVisible(false);
      },
      goBack: function goBack() {
        setSelectedDate(originalSelectedDate);
        setDropDownVisible(false);
      },
      selectedDateText: selectedDays && selectedDays.length !== 0 ? formatDate(selectedDays, formatter) : '',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 7
      }
    }, children);
  }, []);
  return /*#__PURE__*/React.createElement(Calendar, {
    selectedDays: selectedDate,
    availableDays: availableDays,
    defaultOptions: {
      month: currentMonth
    },
    onDayClick: function onDayClick(day
    /*, modifiers, e*/
    ) {
      setSelectedDate(day);
      datePickerProps.onChange(day);
    },
    onMonthChange: function onMonthChange(date) {
      return setCurrentMonth(date);
    },
    Container: Container,
    "data-testid": 'calendar-singleDatePicker',
    disabledDays: disabledDays,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  });
};
export var DateRangeCalendar = function DateRangeCalendar(_ref3) {
  var datePickerProps = _ref3.datePickerProps,
      _ref3$calendarProps = _ref3.calendarProps;
  _ref3$calendarProps = _ref3$calendarProps === void 0 ? {} : _ref3$calendarProps;
  var availableDays = _ref3$calendarProps.availableDays,
      _ref3$calendarProps$d = _ref3$calendarProps.defaultOptions,
      defaultOptions = _ref3$calendarProps$d === void 0 ? {} : _ref3$calendarProps$d,
      useSelectedDate = _ref3.useSelectedDate,
      useDropdownVisible = _ref3.useDropdownVisible,
      formatter = _ref3.formatter,
      disabledDays = _ref3.disabledDays;

  var _useDropdownVisible2 = useDropdownVisible(),
      setDropDownVisible = _useDropdownVisible2.setDropDownVisible;

  var _useSelectedDate2 = useSelectedDate(),
      selectedDate = _useSelectedDate2.selectedDate,
      setSelectedDate = _useSelectedDate2.setSelectedDate;

  var _useState3 = useState(selectedDate || {}),
      _useState4 = _slicedToArray(_useState3, 2),
      range = _useState4[0],
      setRange = _useState4[1];

  var _useState5 = useState(selectedDate && selectedDate.from || defaultOptions.month),
      _useState6 = _slicedToArray(_useState5, 2),
      currentMonth = _useState6[0],
      setCurrentMonth = _useState6[1];

  var from = range.from,
      to = range.to;
  var originalSelectedDate = useMemo(function () {
    return selectedDate;
  }, []);
  useEffect(function () {
    // fire on change when new date(s) picked
    if (Object.keys(range).length !== 0) {
      datePickerProps.onChange(range);
    }
  }, [range]);
  var Container = useCallback(function (_ref4) {
    var children = _ref4.children,
        selectedDays = _ref4.selectedDays;
    return /*#__PURE__*/React.createElement(DatePickerCalendarContainer, {
      onClear: function onClear() {
        setSelectedDate();
        datePickerProps.onChange();
        datePickerProps.onClear();
      },
      onConfirm: function onConfirm() {
        datePickerProps.onConfirm(selectedDays);
        setDropDownVisible(false);
      },
      goBack: function goBack() {
        setSelectedDate(originalSelectedDate);
        setDropDownVisible(false);
      },
      selectedDateText: selectedDays && selectedDays.length !== 0 ? formatDate(selectedDays, formatter) : '',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 7
      }
    }, children);
  }, []); // TODO tests date range select api.

  return /*#__PURE__*/React.createElement(Calendar, {
    selectedDays: selectedDate,
    showSelectedDaysAsRange: !!(from && to),
    onDayClick: function onDayClick(day
    /*, modifiers, e*/
    ) {
      if (!from) {
        setSelectedDate(day);
        setRange({
          from: day
        });
        return;
      }

      if (!to) {
        var dateObj = isAfter(from, day) ? {
          from: day,
          to: from
        } : {
          from: from,
          to: day
        };
        setSelectedDate(dateObj);
        setRange(dateObj);
        return;
      }

      if (from && to) {
        setSelectedDate(day);
        setRange({
          from: day,
          to: null
        });
      }
    },
    availableDays: availableDays,
    onMonthChange: function onMonthChange(date) {
      return setCurrentMonth(date);
    },
    defaultOptions: {
      month: currentMonth
    },
    Container: Container,
    "data-testid": 'calendar-dateRangePicker',
    disabledDays: disabledDays,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 5
    }
  });
};